// RequireAuth.js
import { useAuthenticator } from "@aws-amplify/ui-react"
import { ReactElement } from "react"
import { useLocation, Navigate } from "react-router-dom"

import {
    IS_AUTHENTICATED,
    IS_AUTH_CONFIGURING,
} from "../constants/generalConstants"
import { LOGIN } from "../router/routes"

type RequireAuthProps = {
    children: ReactElement
}
/**
 * Wraps components / routes that demand a user be authenticated. If user
 * is not authenticated, it triggers a redirect to the login screen.
 * Returns null while auth is still configuring to prevent premature
 * redirect during page refresh.
 */
const RequireAuth = ({ children }: RequireAuthProps): ReactElement | null => {
    const location = useLocation()
    const { route, authStatus } = useAuthenticator((context) => [
        context.route,
        context.authStatus,
    ])
    if (authStatus === IS_AUTH_CONFIGURING) {
        return null
    }
    if (route !== IS_AUTHENTICATED) {
        return <Navigate to={LOGIN} state={{ from: location }} replace />
    }
    return children
}
export default RequireAuth
